import QRCode from "react-qr-code";
import { QrCodeProps } from "./types";
import {
  QR_BACKGROUND_COLOR,
  QR_CODE_SIZE,
  QR_FOREGROUND_COLOR
} from "./constants";
import { VStack } from "@gluestack-ui/themed";

export const QrCode = ({
  backgroundColor = QR_BACKGROUND_COLOR,
  foregroundColor = QR_FOREGROUND_COLOR,
  size = QR_CODE_SIZE,
  value,
  showBorder = true
}: QrCodeProps) => {
  return (
    <VStack
      p="$4"
      width={"$fit-content"}
      borderWidth={showBorder ? 1 : 0}
      alignItems="center"
      borderColor="$borderLight200"
      borderRadius={16}
    >
      <QRCode
        size={size}
        bgColor={backgroundColor}
        fgColor={foregroundColor}
        value={value}
        viewBox="0 0 256 256"
      />
    </VStack>
  );
};
